// Dependencies
import axios, { AxiosInstance, AxiosResponse } from "axios";
import _ from "lodash";

// Types
import { Types } from './types';

export default class ExternalAPI {

    protected baseURL: string;
    protected namespace: string;
    protected endpoints: Types.API_Endpoints; 
    protected headers: Types.API_Headers;

    protected axios: AxiosInstance;

    constructor({baseURL, namespace, endpoints, headers}: Types.ExternalAPI) {

        this.baseURL = baseURL;
        this.namespace = namespace;
        this.endpoints = endpoints;
        this.headers = headers;

        this.axios = axios.create({
            baseURL: this.baseURL,
            timeout: 10000,
            headers: this.headers
        })

    }

    async request( endpoint: string, additionalArgs: object | undefined = undefined, namespace: string | undefined = undefined ): Promise<AxiosResponse | null> {

        if ( ! ( endpoint in this.endpoints ) ) {
            throw new Error( `Endpoint "${endpoint}" is not defined.` )
        }

        let requestArgs = this.endpoints[endpoint];

        // NOTE:    Had to save it this ways because it has affected this class property and each request appended that fucking requestArgs.url
        const requestURL = ( ! _.isUndefined( namespace ) ? namespace : this.namespace ) + requestArgs.url;
        requestArgs = {...requestArgs, ...{url: requestURL}};
        
        if ( ! _.isEmpty( additionalArgs ) ) {
            requestArgs = {...requestArgs, ...additionalArgs}
        }
        
        const response = await this.axios.request( requestArgs );

        // TODO:    Check errors after request is made

        return response;

    }
}